import React from 'react';
import { Link } from 'react-router-dom';
import './Card.css';

const Card = ({ image, name, category, url }) => {
  return (
    <div className="card">
      <Link to={url} className="card__link">
        <div className="card__imageWrap">
          <img className="card__image" src={image} alt={name} />
        </div>

        <div className="card__footer">
          <div className="card__text">
            <div className="project_name">{name}</div>
            <div className="project_category">{category}</div>
          </div>

          <div className="card__arrow">→</div>
        </div>
      </Link>
    </div>
  );
};

export default Card;
